import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  constructor() {
    super()
    this.onSubmitHandler = this.onSubmitHandler.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.bindForm()
    this.connectAppsOnSwupTransition()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.unbindForm()
    this.receiver?.disconnect()
  }

  bindForm() {
    this.unbindForm()
    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.form?.addEventListener('submit', this.onSubmitHandler)
  }

  unbindForm() {
    this.form?.removeEventListener('submit', this.onSubmitHandler)
  }

  connectAppsOnSwupTransition() {
    if (typeof window.yotpo?.initWidgets === 'function') {
      window.yotpo?.initWidgets()
    }

    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      window.yotpoWidgetsContainer?.initWidgets()
    }
  }


  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  deepSet(obj, path, value) {
    if (Object(obj) !== obj) return obj
    if (!Array.isArray(path)) path = path.toString().match(/[^.[\]]+/g) || []
    path
      .slice(0, -1)
      .reduce(
        (a, c, i) =>
          Object(a[c]) === a[c]
            ? a[c]
            : (a[c] = Math.abs(path[i + 1]) >> 0 === +path[i + 1] ? [] : {}),
        obj
      )[path[path.length - 1]] = value
    return obj
  }

  formDataObject(form) {
    const formData = new FormData(form)
    const root = {}
    for (const [path, value] of formData) {
      this.deepSet(root, path, value)
    }
    return root
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    const form = this.form
    const button = this.submitButton
    const manageSizeButtons = form?.dataset.sizeButtonsManaged === 'true'
    if (!button) return

    if (manageSizeButtons) {
      if (form.dataset.sizeSubmitting === 'true') return
      if (form.dataset.sizeVariantAvailable === 'false' || button.disabled) return
      form.dataset.sizeSubmitting = 'true'
    }

    button.disabled = true
    button.classList.add('loading')

    try {
      const data = await addToCart(this.formDataObject(form))

      reRenderShopifySections(data)

      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification',
          },
        })
      )
    } finally {
      if (manageSizeButtons) delete form.dataset.sizeSubmitting
      button.disabled = manageSizeButtons && form.dataset.sizeVariantAvailable === 'false'
      button.classList.remove('loading')
    }
  }

  get submitButton() {
    return this.querySelector('[type="submit"]') ?? null
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
